import React from "react";
import MatrixOSInfoShell from "./MatrixOSInfoShell";
import { LegalSection, list } from "./legalContentStyles";

export default function About() {
  return (
    <MatrixOSInfoShell
      eyebrow="About MatrixOS"
      title="One operational layer above the systems you already use."
      subtitle="MatrixOS is built for multi-site operators who need clearer visibility, stronger accountability and faster response without replacing the systems already running the business."
    >
      <LegalSection title="1. The platform">
        MatrixOS connects operational signals from people, schedules, duties, inventory, sites and supported external systems into one operating layer. The goal is simple: make what is happening visible, make ownership clear, and help the right person respond.
      </LegalSection>
      <LegalSection title="2. Neo — Workforce Operations">
        Neo connects published schedules with actual attendance, duties, exceptions and management decisions. Current workflows include clock-in and clock-out visibility, Schedule Intelligence, duty standards, Response Intelligence, manager dashboards, historical reports, decision trails, and supported WhatsApp reminders and escalations.
      </LegalSection>
      <LegalSection title="3. Morpheus — Inventory Intelligence">
        Morpheus turns theoretical stock and imported inventory data into controlled physical-count workflows. It supports inventory preparation, count sessions, section ownership, verification, variance and financial exposure, multi-site visibility, archives, and response alerts when results need attention.
      </LegalSection>
      <LegalSection title="4. Link — Movement & Execution">
        Link is the movement layer for dispatch, queues, handoffs and execution across sites. Link remains in active development and feature availability may differ by rollout until the product is released more broadly.
      </LegalSection>
      <LegalSection title="5. Matrix League — Performance Competition">
        Matrix League turns trusted operating results into visible competition using seasons, divisions, standings and events. Where enabled, scoring can use approved operational results from MatrixOS layers and connected systems, with deeper cross-layer automation continuing to expand as those integrations mature.
      </LegalSection>
      <LegalSection title="6. Existing systems stay in place">
        MatrixOS is designed to sit above systems of record rather than replace them. Depending on the access and capabilities made available by each provider, MatrixOS may consume data from POS, payroll, inventory, delivery, accounting and other operational systems.
      </LegalSection>
      <LegalSection title="7. VARS">
        MatrixOS is designed around four operating outcomes:
        <ul style={list}>
          <li><strong>Visibility:</strong> see what matters across every site.</li>
          <li><strong>Accountability:</strong> know what was expected, what happened and who owns the next action.</li>
          <li><strong>Response:</strong> route issues, escalate when needed and close the loop.</li>
          <li><strong>Scale:</strong> standardise what works and extend it across more locations.</li>
        </ul>
      </LegalSection>
      <LegalSection title="8. Built in South Africa">
        MatrixOS is being built from Cape Town, South Africa, around the realities of live multi-site operations and the systems teams already depend on. MatrixOS is a B-BBEE Level 1 Contributor with 135% B-BBEE procurement recognition.
      </LegalSection>
    </MatrixOSInfoShell>
  );
}
